export const event = {
  maxFileSize: 10 * 1024 * 1024 // 10 MiB
};
